
import React from 'react';
const PermissionModal = ({ isShowing, hide,success, errors, inputValues,isDisabled, handleSubmit, handleInputs }) => {
  return (
    <React.Fragment>  
     <div className="modal-overlay"/>
      <div className="modal-wrapper" aria-modal aria-hidden tabIndex={-1} role="dialog">
        <div className="modal">
          <div className="modal-header">
          <h5 className="modal-title" id="exampleModalLabel">Permission Management</h5>
            <button type="button" className="modal-close-button" data-dismiss="modal" aria-label="Close" onClick={hide}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
       
          <div className="row mb-6 justify-content-center py-4">
            <label className="col-sm-4 col-form-label mb-2">Permission Name</label>
              <div className="col-sm-6 d-flex">
                  <input type="text" className="form-control mb-2" placeholder="" name="permission_name" placeholder=""  value={inputValues.permission_name} onChange={handleInputs}/>
              </div>
              <label className="col-sm-4"></label>
              <div className="col-sm-6 d-flex errorMsg"> {errors.permission_name} </div>
          </div>
          

  <div className="modal-footer ">
  {success.disabled===true ?  <button className="btn btn-primary w-auto px-4" disabled type="button" onClick={handleSubmit}>Save</button> :  <button className="btn btn-primary w-auto px-4"  type="button" onClick={handleSubmit}>Save</button> }
 
  </div>
  </div>
         
          </div>
    </React.Fragment>
          );
        }
               export default PermissionModal;